import styled, { css } from 'styled-components';
import { shade, tint } from 'polished';

import { IDialogOptionProps } from '.';

export const Container = styled.button<IDialogOptionProps>`
  ${({ theme, optionType, marginLeft, disabled }) => css`
    width: 22rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1.2rem 6rem;
    border-radius: ${theme.radius.default};
    background: ${theme.colors.secondary};
    color: #fff;
    font-size: ${theme.fontSizes.default};
    font-weight: 400;

    ${optionType === 'danger' &&
    css`
      background: ${theme.colors.dialogOptionDanger};

      ${disabled
        ? css`
            background-color: ${tint(0.3, theme.colors.dialogOptionDanger)};
            cursor: not-allowed;
          `
        : css`
            :hover {
              background: ${shade(0.2, theme.colors.dialogOptionDanger)};
              transition: 0.2s;
              transform: scale(1.1, 1.1);
            }
          `}
    `}

    ${optionType === 'report' &&
    css`
      background: ${theme.colors.dialogOptionReport};

      ${disabled
        ? css`
            background-color: ${tint(0.3, theme.colors.dialogOptionReport)};
            cursor: not-allowed;
          `
        : css`
            :hover {
              background: ${shade(0.2, theme.colors.dialogOptionReport)};
              transition: 0.2s;
              transform: scale(1.1, 1.1);
            }
          `}
    `}

    ${optionType === 'success' &&
    css`
      background: ${theme.colors.dialogOptionSuccess};

      ${disabled
        ? css`
            background-color: ${tint(0.3, theme.colors.dialogOptionSuccess)};
            cursor: not-allowed;
          `
        : css`
            :hover {
              background: ${shade(0.2, theme.colors.dialogOptionSuccess)};
              transition: 0.2s;
              transform: scale(1.1, 1.1);
            }
          `}
    `}

    ${marginLeft &&
    css`
      margin-left: ${marginLeft};
    `}
  `}
`;
